import axios from 'axios';
import keycloak from '../keycloak/keycloak';

const api = axios.create({
  baseURL: `${window.env.REACT_APP_BASE_URL}`,
});

// 🛫 Request interceptor
api.interceptors.request.use(
  async (config) => {
    // First try to get token from Keycloak instance (most reliable)
    if (keycloak.authenticated && keycloak.token) {
      // Update token if it's about to expire (within 30 seconds)
      try {
        await keycloak.updateToken(30);
      } catch (error) {
        console.error('Token refresh failed:', error);
        keycloak.logout({ redirectUri: window.location.origin });
        return Promise.reject(error);
      }
      
      config.headers.Authorization = `Bearer ${keycloak.token}`;
      console.log('Using Keycloak token');
      return config;
    }
    
    // Fallback to localStorage
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Using localStorage token');
      return config;
    }
    
    // Final fallback to API key
    config.headers.Authorization = `Bearer ${window.env.REACT_APP_LLM_API_KEY}`;
    console.log('Using API key');
    return config;
  },
  (error) => Promise.reject(error)
);

// 🛬 Response interceptor
api.interceptors.response.use(
  (response) => response, // simply return successful responses
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized (401)! Clearing token and logging out...');
      localStorage.removeItem('access_token');
      
      if (keycloak.authenticated) {
        keycloak.logout({
          redirectUri: window.location.origin,
        });
      }
    }
    return Promise.reject(error);
  }
);

export default api;
